import React, { useEffect } from "react";
import BadgeWidget from "./BadgeWidget";
import FloatingWidget from "./FloatingWidget";
import CommonWidget from "./CommonWidget";

const CommonTemplate = ({ selectedTemplate, selectedLayout, isTemplateId, widgetId, reviewTabData }) => {
    // Default values for the reviewTabData
    const {
        is_website_frontend,
    } = reviewTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/g2-reviews/temp-css/CommonTemplate.css`;
        if (widgetId) {
            link.setAttribute("g2-reviews-data-dynamic-css", "g2-reviews");
        } else {
            link.setAttribute("data-dynamic-css", "g2-reviews");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="g2-reviews"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    return (
        <>
            <div className={`upgadeify-review-template-main ${is_website_frontend}`} >
                <div className='upgadeify-review-template-inner'>
                    {selectedTemplate === "Badge_Widget" && selectedLayout === "badge_layout" ? (
                        <BadgeWidget selectedLayout={selectedLayout} isTemplateId={isTemplateId} widgetId={widgetId} reviewTabData={reviewTabData}  />
                    ) : selectedTemplate === "Floating_Badge" && selectedLayout === "floating_badge_layout" ? (
                        <FloatingWidget selectedLayout={selectedLayout} isTemplateId={isTemplateId} widgetId={widgetId} reviewTabData={reviewTabData} />
                    ) : (
                        <CommonWidget selectedLayout={selectedLayout} isTemplateId={isTemplateId} widgetId={widgetId} reviewTabData={reviewTabData} />
                    )}
                </div>
            </div>
        </>
    );
};

export default CommonTemplate;
